package fr.manyverse.app.infrastructure.auth

import fr.manyverse.app.domain.error.DomainException
import fr.manyverse.app.infrastructure.error.mapToDomainException
import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

/**
 * Échecs de l'échange du code OAuth au retour du navigateur, sur Android et iOS.
 *
 * Cet échange est lancé par le deep link, hors de tout appel du ViewModel : sans ce relais,
 * l'utilisateur resterait sur l'écran de connexion sans savoir que sa connexion a échoué.
 */
class OAuthCallbackFailures {

    private val _failures = MutableSharedFlow<DomainException>(
        extraBufferCapacity = 1,
        onBufferOverflow = BufferOverflow.DROP_OLDEST
    )
    val failures: SharedFlow<DomainException> = _failures.asSharedFlow()

    /** Le mapper remonte l'échec à Sentry s'il est anormal (pas pour une panne réseau). */
    fun report(exception: Throwable) {
        _failures.tryEmit(mapToDomainException(exception, "auth"))
    }
}
